import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { Edit2, Trash2 } from "react-feather";
import { TaxUnit } from "../../../../../models";
import { useMainLocale } from "../../../../../context/MainLocaleContext";
import { thousandize } from "../../../../../util/formatting";
import { TaxUnitDeleteModal } from "../../TaxUnitModal/TaxUnitDeleteModal";
import { TaxUnitEditModal } from "../../TaxUnitModal/TaxUnitEditModal";
import { GenericList } from "../GenericList";
import { ListRow } from "../GenericListRow";
import { DKTaxUnitList } from "./DKTaxUnitList";
interface TaxUnitListLabels {
  sumDonationsLabel: string;
  sumTaxDeductionsLabel: string;
  sumTaxBenefitLabel: string;
}
const TaxUnitListStandard: React.FC<{
  taxUnits: TaxUnit[];
} & TaxUnitListLabels> = t0 => {
  const $ = _c(38);
  const {
    taxUnits,
    sumDonationsLabel,
    sumTaxDeductionsLabel,
    sumTaxBenefitLabel
  } = t0;
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [selectedTaxUnit, setSelectedTaxUnit] = useState(null);
  const unit = taxUnits[0];
  let t1;
  if ($[0] !== unit.ssn) {
    t1 = unit.ssn.length === 11 ? unit.ssn.replace(/(\d{6})(\d{5})/, "$1 $2") : unit.ssn.replace(/(\d{3})(\d{3})(\d{3})/, "$1 $2 $3");
    $[0] = unit.ssn;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const suplementalInformation = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      label: "",
      width: "10%"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== sumDonationsLabel) {
    t3 = {
      label: sumDonationsLabel,
      width: "30%"
    };
    $[3] = sumDonationsLabel;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== sumTaxDeductionsLabel) {
    t4 = {
      label: sumTaxDeductionsLabel,
      width: "30%"
    };
    $[5] = sumTaxDeductionsLabel;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== sumTaxBenefitLabel) {
    t5 = {
      label: sumTaxBenefitLabel,
      width: "30%"
    };
    $[7] = sumTaxBenefitLabel;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t4 || $[11] !== t5) {
    t6 = [t2, t3, t4, t5];
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const headers = t6;
  let rows;
  if ($[13] !== unit) {
    const filteredDeductions = unit.taxDeductions?.filter(_temp) || [];
    let t7;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <Edit2 size={16} />;
      $[15] = t7;
    } else {
      t7 = $[15];
    }
    let t8;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <Trash2 size={16} />;
      $[16] = t8;
    } else {
      t8 = $[16];
    }
    const contextOptions = [{
      label: "Endre",
      icon: t7
    }, {
      label: "Slett",
      icon: t8
    }];
    let t9;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = (option, element) => {
        bb19: switch (option) {
          case "Endre":
            {
              setSelectedTaxUnit(element);
              setEditModalOpen(true);
              break bb19;
            }
          case "Slett":
            {
              setSelectedTaxUnit(element);
              setDeleteModalOpen(true);
            }
        }
      };
      $[17] = t9;
    } else {
      t9 = $[17];
    }
    const context = {
      contextOptions,
      onContextSelect: t9
    };
    rows = filteredDeductions.map((deductions, i) => {
      const row = {
        id: `${unit.id.toString()}${deductions.year}`,
        defaultExpanded: false,
        cells: [{
          value: deductions.year.toString()
        }, {
          value: thousandize(Math.round(deductions.sumDonations)) + " kr"
        }, {
          value: thousandize(Math.round(deductions.deduction)) + " kr"
        }, {
          value: thousandize(Math.round(deductions.benefit)) + " kr"
        }],
        element: unit
      };
      if (i === 0) {
        return {
          ...row,
          ...context
        };
      }
      return row;
    });
    let t10;
    if ($[18] !== unit.id) {
      t10 = unit.id.toString();
      $[18] = unit.id;
      $[19] = t10;
    } else {
      t10 = $[19];
    }
    let totalsRow = {
      id: `${t10}total`,
      defaultExpanded: false,
      cells: [{
        value: "Totalt"
      }, {
        value: thousandize(Math.round(filteredDeductions.reduce(_temp2, 0))) + " kr"
      }, {
        value: thousandize(Math.round(filteredDeductions.reduce(_temp3, 0))) + " kr"
      }, {
        value: thousandize(Math.round(filteredDeductions.reduce(_temp4, 0))) + " kr"
      }],
      element: unit
    };
    if (filteredDeductions.length === 0) {
      totalsRow = {
        ...totalsRow,
        ...context
      };
    }
    rows.push(totalsRow);
    $[13] = unit;
    $[14] = rows;
  } else {
    rows = $[14];
  }
  let t7;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div>Det mangler informasjon for skatteenheten.</div>;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div>{t7}<div>Ta kontakt på <a href="mailto: donasjon@gieffektivt.no">donasjon@gieffektivt.no</a>.</div></div>;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  const emptyPlaceholder = t8;
  let t9;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = [30, 60];
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== headers || $[24] !== rows || $[25] !== suplementalInformation || $[26] !== unit.name) {
    t10 = <GenericList title={unit.name} supplementalInformation={suplementalInformation} headers={headers} rows={rows} emptyPlaceholder={emptyPlaceholder} expandable={false} proportions={t9} />;
    $[23] = headers;
    $[24] = rows;
    $[25] = suplementalInformation;
    $[26] = unit.name;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== editModalOpen || $[29] !== selectedTaxUnit) {
    t11 = editModalOpen && selectedTaxUnit && <TaxUnitEditModal open={editModalOpen} initial={selectedTaxUnit} onClose={() => setEditModalOpen(false)} onSuccess={() => setEditModalOpen(false)} onFailure={_temp5} />;
    $[28] = editModalOpen;
    $[29] = selectedTaxUnit;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== deleteModalOpen || $[32] !== selectedTaxUnit) {
    t12 = deleteModalOpen && selectedTaxUnit && <TaxUnitDeleteModal open={deleteModalOpen} taxUnit={selectedTaxUnit} onSuccess={success => {
      setDeleteModalOpen(success);
    }} onFailure={_temp6} onClose={() => setDeleteModalOpen(false)} />;
    $[31] = deleteModalOpen;
    $[32] = selectedTaxUnit;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  let t13;
  if ($[34] !== t10 || $[35] !== t11 || $[36] !== t12) {
    t13 = <>{t10}{t11}{t12}</>;
    $[34] = t10;
    $[35] = t11;
    $[36] = t12;
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  return t13;
};
export const TaxUnitList: React.FC<{
  taxUnits: TaxUnit[];
} & TaxUnitListLabels> = t0 => {
  const $ = _c(10);
  const {
    taxUnits,
    sumDonationsLabel,
    sumTaxDeductionsLabel,
    sumTaxBenefitLabel
  } = t0;
  const mainLocale = useMainLocale();
  if (mainLocale === "dk") {
    let t1;
    if ($[0] !== sumDonationsLabel || $[1] !== sumTaxBenefitLabel || $[2] !== sumTaxDeductionsLabel || $[3] !== taxUnits) {
      t1 = <DKTaxUnitList taxUnits={taxUnits} sumDonationsLabel={sumDonationsLabel} sumTaxDeductionsLabel={sumTaxDeductionsLabel} sumTaxBenefitLabel={sumTaxBenefitLabel} />;
      $[0] = sumDonationsLabel;
      $[1] = sumTaxBenefitLabel;
      $[2] = sumTaxDeductionsLabel;
      $[3] = taxUnits;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    return t1;
  }
  let t1;
  if ($[5] !== sumDonationsLabel || $[6] !== sumTaxBenefitLabel || $[7] !== sumTaxDeductionsLabel || $[8] !== taxUnits) {
    t1 = <TaxUnitListStandard taxUnits={taxUnits} sumDonationsLabel={sumDonationsLabel} sumTaxDeductionsLabel={sumTaxDeductionsLabel} sumTaxBenefitLabel={sumTaxBenefitLabel} />;
    $[5] = sumDonationsLabel;
    $[6] = sumTaxBenefitLabel;
    $[7] = sumTaxDeductionsLabel;
    $[8] = taxUnits;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  return t1;
};
function _temp(d) {
  return d.sumDonations > 0;
}
function _temp2(acc, cur) {
  return acc + cur.sumDonations;
}
function _temp3(acc_0, cur_0) {
  return acc_0 + cur_0.deduction;
}
function _temp4(acc_1, cur_1) {
  return acc_1 + cur_1.benefit;
}
function _temp5() {}
function _temp6() {}